<template>
  <div class="font_style_group">
    <span
      v-for="item in options"
      :key="item.value"
      :class="['style_item', 'style_item_' + item.value, align === item.value ? 'style_item_active' : '']"
      @click="on_click_align(item)"
    >
        <i class="iconfont icon " :class="item.icon"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'MyFontStyle',
  data() {
    return {
      align: this.value,
      options: [{
        label: '左',
        value: 'left',
        icon: 'icon-zuoduiqi16'
      }, {
        label: '中',
        value: 'center',
        icon: 'icon-juzhongduiqi16'
      }, {
        label: '右',
        value: 'right',
        icon: 'icon-youduiqi16'
      }, {
        label: '两端',
        value: 'justify',
        icon: 'icon-liangduanduiqi16'
      }]
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value() {
      this.align = this.value
    }
    // align() {
    //   this.$emit('update:value', this.align)
    // }
  },
  methods: {
    on_click_align(align) {
      this.align = align.value
      this.$emit('update:value', this.align)
      this.$emit('changeTextAlign', align)
    }
  }
}
</script>

<style lang="scss" scoped>
.font_style_group {
  margin-top: 20px;
}

.font_style_group {
  user-select: none;
  border: 1px solid #E8E8F0;
}
.style_item {
  display: inline-block;
  flex: 1;
  height: 32px;
  line-height: 32px;
//   border-radius: 4px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  cursor: pointer;
  text-align: center;
  .iconfont{
    color: #4E5969;
  }
  &:not(:last-child){
    border-right: #E5E6EB solid 1px;
  }
}

.style_item_active {
  background-color: #F0F0F0;
//   border-radius: 4px;
  // background-color: rgba(0, 134, 255, 0.1);
  // border: 1px solid #0086FF;
  // color: #fff;
}

.style_item_left {
//   background-image: url("/img/icon-font-align-left.svg");
}

.style_item_right {
//   background-image: url("/img/icon-font-align-right.svg");
}

.style_item_center {
//   background-image: url("/img/icon-font-align-center.svg");
}

.style_item_justify {
//   background-image: url("/img/icon-font-align-justify.svg");
}
</style>
